import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const BrandContext = createContext(null);

const setIcon = (rel, href, type) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!href) { if (el && el.dataset.dynamic) el.remove(); return; }
  if (!el) { el = document.createElement("link"); el.rel = rel; document.head.appendChild(el); }
  el.dataset.dynamic = "1";
  el.href = href;
  if (type) el.type = type;
};

export const BrandProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [failed, setFailed] = useState(false);

  const reload = useCallback(() => api.get("/config").then((r) => setConfig(r.data)).catch(() => setFailed(true)), []);
  useEffect(() => { reload(); }, [reload]);

  useEffect(() => {
    const b = config?.brand;
    if (!b) return;
    setIcon("icon", b.favicon_url, b.favicon_url?.includes("/favicon") ? "image/png" : undefined);
    setIcon("apple-touch-icon", b.apple_icon_url);
  }, [config]);

  if (!config) {
    return (
      <div className="min-h-screen grid place-items-center bg-white" data-testid="app-loading">
        <div className="text-center">
          <div className="w-10 h-10 mx-auto bg-amber-500 pulse-ring" />
          <p className="mt-5 font-mono text-xs tracking-[0.3em] text-slate-500 uppercase">
            {failed ? "Unable to load. Please refresh." : "Loading"}
          </p>
        </div>
      </div>
    );
  }
  return <BrandContext.Provider value={{ ...config, reload }}>{children}</BrandContext.Provider>;
};

export const useConfig = () => useContext(BrandContext);
export const useBrand = () => useContext(BrandContext).brand;

export const LogoMark = ({ size = "w-10 h-10", className = "", testid }) => {
  const b = useBrand();
  if (b.logo_url) {
    return <img src={b.logo_url} alt={`${b.company} logo`} className={`${size} rounded-full object-cover border border-slate-200 bg-white shrink-0 ${className}`} data-testid={testid} />;
  }
  return (
    <span className={`${size} relative bg-amber-500 grid place-items-center shrink-0 overflow-hidden ${className}`} data-testid={testid}>
      <span className="font-display font-black text-slate-900 text-xl tracking-tight">ET</span>
      <span className="absolute bottom-0 left-0 right-0 h-1 hazard opacity-70" />
    </span>
  );
};
